import { IAreaTeamAvailability } from '../../interfaces/iarea-team-availability';
import { AreaTeam } from '../area-team';

export class AreaTeamAvailabilityBase {
  AreaTeamAvailabilityId: number;
  AreaTeamId: number;
  StartDate: Date;
  EndDate: Date;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AreaTeam?: AreaTeam;

  constructor(item?: IAreaTeamAvailability) {
    if (item) {

      this.AreaTeamAvailabilityId = item.AreaTeamAvailabilityId;
      this.AreaTeamId = item.AreaTeamId;
      this.StartDate = item.StartDate ? new Date(item.StartDate) : null;
      this.EndDate = item.EndDate ? new Date(item.EndDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AreaTeam = new AreaTeam(item.AreaTeam);
    }
  }
}